@import "./dashboard-carousel-item/dashboard-carousel-item.scss";
@import "../../dashboard-item-header/dashboard-item-header.scss";

.dashboard-view-carousel {
  display: block;
  position: relative;

  &__title {
    font-size: 18px;
    font-weight: 600;
    margin: 20px 0;
  }

  .item-header {
    margin-bottom: 20px;
  }
}
